import { createContext, Suspense, useContext, useEffect } from "react";
import Router from "./Router";
import ProviderApp, { ThemeContext } from "./ProviderApp";
import { CellPortalHost } from "@CubeComponents/html/cellPortals";
import UserProfileModalHost from "@Components/UserProfileModalComponent/UserProfileModalHost";

declare const PubSubHelper: any;

export const PubSubContext = createContext({
  PubSubHelper: PubSubHelper,
});

function App() {
  const { theme } = useContext(ThemeContext) as any;

  useEffect(() => {
    if (process.env.REACT_APP_ENV == "development") {
      document.cookie = "cookieForCypress=run_cypress_local; path=/; max-age=86400; SameSite=Lax";
    }
  }, []);

  return (
    <ProviderApp>
      {/* [portal-pilot] single host that renders SlickGrid cell React content via portals under the app providers */}
      <CellPortalHost />
      {/* single app-level mount for user-profile modals opened from plain-DOM grid cells */}
      <UserProfileModalHost />
      <div
        className="App"
        style={{
          opacity: 1,
          background: `var(${theme.rootBackground})`,
          color: `var(${theme.rootTextColor})`,
        }}
      >
        <Suspense fallback={<></>}>
          <Router />
        </Suspense>
      </div>
    </ProviderApp>
  );
}

export default App;
